export default {
  categories: [],
  currentcategory: '',
};
